// kebab-case per the MDN spec
// https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete

export enum InputAutocomplete {
  Default = "",
  Username = "username",
  NewUsername = "new-username",
  CurrentPassword = "current-password",
  NewPassword = "new-password",
  Email = "email",
  Organization = "organization",
  FirstName = "given-name",
  LastName = "family-name",
  FullName = "name",
  StreetAddress = "street-address",
  CountryName = "country-name",
  Country = "country",
  PostalCode = "postal-code",
  Telephone = "tel",
  TelephoneNational = "tel-national",
  TelephoneCountryCode = "tel-country-code",
  Birthday = "bday",
  HonorificPrefix = "honorific-prefix",
  Off = "off",
}
